<template lang="pug">
  .b2b-page-add-parties-services-country-nif
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('new_party.country_nif.title') }}
      ods-form(
        ref='projectPartiesAddNifEditForm',
        :model='projectPartiesAddNifEditForm',
        :rules='projectPartiesAddNifFormRules',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row.info
          ods-col(:span='24')
            p {{ $t('new_party.country_nif.info') }}

        //- NIF y listado de paises
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("new_party.country_nif.form.country.label")',
              prop='countryId')
              ods-select(
                v-model='projectPartiesAddNifEditForm.countryId',
                filterable,
                :placeholder='$t("new_party.country_nif.form.country.placeholder")')
                ods-option(
                  v-for='option in countries',
                  :key='option.id',
                  @click.native='handleClickCountry(option.name)'
                  :label='$t("countries.country_" + option.codeAlfa3)',
                  :value='option.id')
            ods-form-item(
              :label='$t("new_party.country_nif.form.identification_number.label")',
              prop='taxIdentificationNumber')
              ods-input(
                v-model='projectPartiesAddNifEditForm.taxIdentificationNumber')

    ods-row.form-actions
      ods-col(:span='24')
        ods-button(
          type='primary',
          size='large'
          @click='handleGoNewParty("projectPartiesAddNifEditForm")')
          | {{ $t('buttons.btnNext') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-add-parties-services-country-nif',
  mixins: [Utils],
  data () {
    return {
      countryName: null,
      projectPartiesAddNifEditForm: {
        taxIdentificationNumber: null,
        countryId: null
      },

      // Validaciones
      projectPartiesAddNifFormRules: {
        taxIdentificationNumber: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        countryId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      }
    }
  },

  components: {
    B2bTimeline
  },
  computed: {
    ...mapGetters([
      'countries'
    ])
  },

  methods: {
    ...mapActions([
      'createProjectParty',
      'getServiceDetail'
    ]),

    handleClickCountry (data) {
      this.countryName = data
    },

    /** Validamos datos para verificar si podemos redirigir a la siguiente pantalla  */
    handleGoNewParty (formName) {
      this.$refs[formName].validate(async (valid) => {
        let validOk = true
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.validating_data')
          })
          try {
            await this.createProjectParty({
              projectPartyData: {
                projectId: this.$route.params.projectId,
                taxIdentificationNumber: this.projectPartiesAddNifEditForm.taxIdentificationNumber,
                countryId: this.projectPartiesAddNifEditForm.countryId,
                validate: true
              }
            })
          } catch (error) {
            validOk = false
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
          // Redirigimos si todo ok
          if (validOk) {
            const response = await this.getServiceDetail(this.$route.params.projectId)
            sessionStorage.setItem('projectName', response.name)

            router.push({
              name: 'new-parties-service',
              params: {
                taxIdentificationNumber: this.projectPartiesAddNifEditForm.taxIdentificationNumber,
                countryId: this.projectPartiesAddNifEditForm.countryId,
                projectId: this.$route.params.projectId,
                countryName: this.countryName,
                projectName: response.name
              }
            })
          }
        }
      })
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 404:
          errorSms = 'global_error'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-add-parties-services-country-nif {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
